import { render, staticRenderFns } from "./ProjectMember.vue?vue&type=template&id=33cff781&scoped=true&"
import script from "./ProjectMember.vue?vue&type=script&lang=js&"
export * from "./ProjectMember.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cff781",
  null
  
)

export default component.exports